module.exports = __webpack_public_path__ + "static/img/gnmk_7@2x.1e04381e.png";